export default "__VITE_ASSET__BjZyn0$y__"